import { createSlice } from "@reduxjs/toolkit";
import APPCONFIG from "constants/appConfig";
import axios from "axios";

// initial state
export const initialState = {
  errorMessage: "",
  loading: false,
  today: null,
  currentWeekNumber: null,
  selectedWeekNumber: null,
  selectedDay: false,
  dates: {}, // list with dates for weeks, keys are weeknumber, items are dates in sap format
  menus: {} // list with menus for weeks'
};

export const scheduledataSlice = createSlice({
  name: "scheduledata",
  initialState,
  reducers: {
    scheduledata_setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    scheduledata_setLoading: (state, action) => {
      state.loading = action.payload;
    },
    scheduledata_setToday: (state, action) => {
      state.today = action.payload;
    },
    scheduledata_setCurrentWeekNumber: (state, action) => {
      state.currentWeekNumber = action.payload;
      state.selectedWeekNumber = action.payload;
      state.dates = getDates(action.payload);
    },
    scheduledata_setSelectedWeekNumber: (state, action) => {
      state.selectedWeekNumber = action.payload;
    },
    scheduledata_setSelectedDay: (state, action) => {
      state.selectedDay = action.payload;
    },
    scheduledata_setDates: (state, action) => {
      state.dates = action.payload;
    },
    scheduledata_setMenus: (state, action) => {
      let key = Object.keys(action.payload)[0];
      return {
        ...state,
        menus: { ...state.menus, [key]: action.payload[key] }
      };
    },
    scheduledata_updateMenuForDay: (state, action) => {
      // update one single menu for one single day
      console.log("update menu for one day", action.payload);
      let weeknumber = action.payload.weeknumber;
      let date = action.payload.date;
      let values = action.payload.values;
      let saved = action.payload.savedToSap ? action.payload.savedToSap : false;

      if (!state.menus[weeknumber]) {
        state.menus[weeknumber] = {};
      }

      let toUpdate = {
        ...state.menus[weeknumber][date],
        MENU_DATE: date,
        savedToSap: saved
      };

      Object.keys(values).map(key => {
        toUpdate[key] = values[key];
      });

      state.menus[weeknumber][date] = toUpdate;
    }
  }
});

export const {
  scheduledata_setLoading,
  scheduledata_setToday,
  scheduledata_setCurrentWeekNumber,
  scheduledata_setSelectedWeekNumber,
  scheduledata_setSelectedDay,
  scheduledata_setDates,
  scheduledata_setMenus,
  scheduledata_updateMenuForDay,
  scheduledata_setAppLanguage,
  scheduledata_setErrorMessage
} = scheduledataSlice.actions;

export const scheduledataSelector = state => state.scheduledata;

export default scheduledataSlice.reducer;

export function scheduledata_fetchData(dates) {
  console.log("scheduledata - fetchData", dates);
  return async (dispatch, getState) => {
    if (getState().scheduledata.loading) {
      console.log("scheduledata already loading");
      return;
    }

    dispatch(scheduledata_setLoading(true));

    var weeknumber = getState().scheduledata.selectedWeekNumber;

    let week = getState().scheduledata.dates[weeknumber];
    console.log("week",Object.values(week));
    console.log("week1",Object.values(week).join());

    axios
      .get(
        APPCONFIG.host +
          "api/lunchorder/scheduleForDays/" +
          JSON.stringify(Object.values(week).join()),
        {
          withCredentials: true,
          timeout: APPCONFIG.axiosTimeout,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        }
      )
      .then(response => {
        console.log("scheduledata  got response", response);
        if (response.status != 200) {
          console.log("scheduledata invalid response", response);
          dispatch(scheduledata_setErrorMessage(response.statusText));
        } else {
          // map days to simple objects incuding a 'saved to sap' variable
          dispatch(
            scheduledata_setMenus({
              [weeknumber]: formatDays(JSON.parse(response.data).data)
            })
          );
        }

        dispatch(scheduledata_setLoading(false));
      })
      .catch(er => {
        console.error("scheduledata error", er);
        //dispatch(setError());
        dispatch(scheduledata_setLoading(false));
      });
  };
}

export function scheduledata_saveData(state) {
  console.log("scheduledata - save");

  return async (dispatch, getState) => {
    console.log("scheduledata - save data", getState().scheduledata.menus);
    const axiosConfig = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      withCredentials: true
    };

    axios
      .post(
        APPCONFIG.host + "api/lunchorder/schedule",
        {
          items: getState().scheduledata.menus
        },
        axiosConfig
      )
      .then(response => {
        console.log("items saved", response);

        // get all the saved days according to the response
        // as a formatted list (with objects)
        let days = formatDays(JSON.parse(response.data).data);

        // call the update single day for each day that has been updated
        // to fill them with sap data and set the saved parameter to true
        console.log("go get current week number based on date");
        Object.keys(days).map(day => {
          // we do not have the weeknumber in the sap data, but we need it
          // to save the date to the correct week in the list
          // so first we need to find weeknumber based on date
          let weekNumber = null;
          Object.keys(getState().scheduledata.dates).map(number => {
            if (getState().scheduledata.dates[number].includes(day)) {
              console.log("weeknumber found", number);
              weekNumber = number;
            }
          });

          console.log("got current weeknumber based on date");

          if (weekNumber) {
            // if the weeknumber is found we have all the data to update
            // the menus for the day in the list
            let tmp = {
              savedToSap: true,
              weeknumber: weekNumber,
              date: day,
              values: {
                MENU1_NUMB: days[day].MENU1_NUMB,
                MENU2_NUMB: days[day].MENU2_NUMB,
                MENU3_NUMB: days[day].MENU3_NUMB
              }
            };

            // call the update for the day
            dispatch(scheduledata_updateMenuForDay(tmp));
          }
        });
      })
      .catch(error => {
        console.log("error", error);
      });
  };
}

// internal function
// internal function
// internal function
// internal function

function formatDays(weekdata) {
  let week = {};
  Object.keys(weekdata).map(key => {
    let day = {
      savedToSap: true,
      MENU1_NUMB: weekdata[key]["MENU1_NUMB"],
      MENU2_NUMB: weekdata[key]["MENU2_NUMB"],
      MENU3_NUMB: weekdata[key]["MENU3_NUMB"],
      MENU_DATE: weekdata[key]["MENU_DATE"]
    };
    week[key] = day;
  });
  return week;
}

function getDates(currentWeekNumber) {
  console.log("scheduledata - set week dates");
  let weeks = {};

  // go get last monday
  // go get last monday
  // go get last monday
  var prevMonday = new Date();
  prevMonday.setDate(prevMonday.getDate() - ((prevMonday.getDay() + 6) % 7));

  // loop through four weeks ahead
  for (var week = 0; week < 4; week++) {
    let singleWeek = {};
    var weekAddition = week * 7;
    for (var day = 0; day < 5; day++) {
      // calculate correct date = previous monday + days ahead, based on days and weeks
      var dayOfWeek = addDays(prevMonday, day + weekAddition);
      let date =
        dayOfWeek.getFullYear() +
        "" +
        (dayOfWeek.getUTCMonth() + 1).toString().padStart(2, "0") +
        "" +
        dayOfWeek
          .getUTCDate()
          .toString()
          .padStart(2, "0");

      singleWeek[Object.keys(singleWeek).length] = date;
    }
    weeks[currentWeekNumber + week] = singleWeek;
  }

  return weeks;
}

function addDays(monday, days) {
  var date = new Date(monday.valueOf());
  date.setDate(date.getDate() + days);
  return date;
}
